// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .container {
  margin-top: 20px;
}
:host .var-ref {
  display: block;
}
:host .var-ref flex-variable {
  display: inline-block;
}
:host .var-ref flex-variable ::ng-deep .value {
  margin-right: 10px;
}
:host .var-ref flex-variable ::ng-deep .variable-input {
  min-width: 400px;
}
:host .var-ref span {
  margin-left: 5px;
  margin-right: 5px;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/app/gauges/gauge-property/flex-widget-property/flex-widget-property.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/gauges/gauge-property/flex-widget-property/flex-widget-property.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;ACAR;ADEI;EACI,cAAA;ACAR;ADCQ;EACI,qBAAA;ACCZ;ADCY;EACI,kBAAA;ACChB;ADCY;EACI,gBAAA;ACChB;ADEQ;EACI,gBAAA;EACA,iBAAA;EACA,qBAAA;ACAZ","sourcesContent":[":host {\n    .container {\n        margin-top: 20px;\n    }\n    .var-ref {\n        display: block;\n        flex-variable {\n            display: inline-block;\n\n            ::ng-deep .value {\n                margin-right: 10px;\n            }\n            ::ng-deep .variable-input {\n                min-width: 400px;\n            }\n        }\n        span {\n            margin-left: 5px;\n            margin-right: 5px;\n            display: inline-block;\n        }\n    }\n}",":host .container {\n  margin-top: 20px;\n}\n:host .var-ref {\n  display: block;\n}\n:host .var-ref flex-variable {\n  display: inline-block;\n}\n:host .var-ref flex-variable ::ng-deep .value {\n  margin-right: 10px;\n}\n:host .var-ref flex-variable ::ng-deep .variable-input {\n  min-width: 400px;\n}\n:host .var-ref span {\n  margin-left: 5px;\n  margin-right: 5px;\n  display: inline-block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
